import React from "react";
import "date-fns";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Conclusion from "./Conclusion";
import Archivos from "./Archivos";
import IconButton from "@material-ui/core/IconButton";
import DescriptionIcon from "@material-ui/icons/Description";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import SnackBar from "../../SnackBar";
const firebase = require("firebase");
require("firebase/firestore");

class Etapa1 extends React.Component {
  constructor() {
    // antes de pasarlos al state
    super();
    this.state = {
      id: "",
      created: false,
      numSinsitro: "",
      nombInsti: "",
      fechaReclamo: null,
      fechaReclamoP: [],
      coment1: "",
      fechaRespueRecl: null,
      fechaRespueReclP: [],
      coment2: "",
      fechaInfoAdici: null,
      fechaInfoAdiciP: [],
      coment3: "",
      fechaEntregInfAdi: null,
      fechaEntregInfAdiP: [],
      coment4: "",
      fechaEntregInfFin: null,
      fechaEntregInfFinP: [],
      coment5: "",
      fechaRespFinalAseg: null,
      fechaRespFinalAsegP: [],
      coment6: "",
      fechaInformeFinal: null,
      fechaInformeFinalP: [],
      coment7: "",
      descr: "",
      open: false,
      openPdf: false,
      archivoState: null,
      guardado: false,
      lista: "",
    };

    this.handleReclamo = this.handleReclamo.bind(this);
    this.handleRespRec = this.handleRespRec.bind(this);
    this.handleInfoAdic = this.handleInfoAdic.bind(this);
    this.handleEntregInfAdi = this.handleEntregInfAdi.bind(this);
    this.handleEntregInfFin = this.handleEntregInfFin.bind(this);
    this.handleRespFinAseg = this.handleRespFinAseg.bind(this);
    this.handleInfoFin = this.handleInfoFin.bind(this);
  }

  componentDidMount = async () => {
    //const notaSeleccionada = await this.props.notes[this.props.index];
    if (this.props.selectedNote.fase1) {
      const notaSeleccionada = await this.props.notes.filter(
        (i) => i.id === this.props.selectedNote.id
      )[0];

      await this.fullFields(notaSeleccionada.fase1);
      this.setState({ created: true });
    }
  };

  fullFields = (data) => {
    this.setState({
      id: data.id,
      numSinsitro: data.numSinsitro,
      //nombInsti: data.nombInsti,
      nombInsti: this.props.selectedNote.aseguradora,
      fechaReclamo: data.fechaReclamo ? data.fechaReclamo.toDate() : null,
      coment1: data.coment1,
      fechaRespueRecl: data.fechaRespueRecl
        ? data.fechaRespueRecl.toDate()
        : null,
      coment2: data.coment2,
      fechaInfoAdici: data.fechaInfoAdici ? data.fechaInfoAdici.toDate() : null,
      coment3: data.coment3,
      fechaEntregInfAdi: data.fechaEntregInfAdi
        ? data.fechaEntregInfAdi.toDate()
        : null,
      coment4: data.coment4,
      fechaEntregInfFin: data.fechaEntregInfFin
        ? data.fechaEntregInfFin.toDate()
        : null,
      coment5: data.coment5,
      fechaRespFinalAseg: data.fechaRespFinalAseg
        ? data.fechaRespFinalAseg.toDate()
        : null,
      coment6: data.coment6,
      fechaInformeFinal: data.fechaInformeFinal
        ? data.fechaInformeFinal.toDate()
        : null,
      coment7: data.coment7,
      fechaReclamoP: data.fechaReclamoP,
      fechaRespueReclP: data.fechaRespueReclP,
      fechaInfoAdiciP: data.fechaInfoAdiciP,
      fechaEntregInfAdiP: data.fechaEntregInfAdiP,
      fechaEntregInfFinP: data.fechaEntregInfFinP,
      fechaRespFinalAsegP: data.fechaRespFinalAsegP,
      fechaInformeFinalP: data.fechaInformeFinalP,
    });
  };

  handleReclamo(date) {
    this.setState({ fechaReclamo: date });
  }

  handleRespRec(date) {
    this.setState({ fechaRespueRecl: date });
  }

  handleInfoAdic(date) {
    this.setState({ fechaInfoAdici: date });
  }

  handleEntregInfAdi(date) {
    this.setState({ fechaEntregInfAdi: date });
  }

  handleEntregInfFin(date) {
    this.setState({ fechaEntregInfFin: date });
  }

  handleRespFinAseg(date) {
    this.setState({ fechaRespFinalAseg: date });
  }
  handleInfoFin(date) {
    this.setState({ fechaInformeFinal: date });
  }
  handleClose = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  handleClick = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  render() {
    return (
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid>
            <div style={{ width: "100%", display: "flex" }}>
              <TextField
                style={{ marginRight: "10px" }}
                id="outlined-name"
                label="Numero del Siniestro"
                value={this.state.numSinsitro}
                onChange={(e) => this.setState({ numSinsitro: e.target.value })}
                margin="normal"
                variant="outlined"
              />
              <TextField
                style={{ display: "felx-start" }}
                id="outlined-name"
                label="Nombre de Instutucion"
                // value={this.state.nombInsti}
                value={
                  this.props.selectedNote
                    ? this.props.selectedNote.aseguradora
                    : ""
                }
                onChange={(e) => this.setState({ nombInsti: e.target.value })}
                margin="normal"
                variant="outlined"
                disabled
              />
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Reclamo ante la Institucion"
                value={this.state.fechaReclamo}
                onChange={this.handleReclamo}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaReclamoP"
                key="fechaReclamoP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label
                // disabled={window.respuesta.checkedF}
                htmlFor="fechaReclamoP"
              >
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaReclamoP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment1}
                onChange={(e) =>
                  this.setState({
                    coment1: e.target.value,
                    descr: e.target.value,
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none",
                }}
              />{" "}
              {/*/         
              <Button
                onClick={() => this.pdfAction("fechaReclamoP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>  aqui esta el boton de fechaReclamoP*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Respuesta de Reclamo"
                value={this.state.fechaRespueRecl}
                onChange={this.handleRespRec}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                key="fechaRespueReclP"
                id="fechaRespueReclP"
                onChange={this.onChangeHandler}
                multiple
                type="file"
              />
              <label htmlFor="fechaRespueReclP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaRespueReclP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment2}
                onChange={(e) =>
                  this.setState({
                    coment2: e.target.value,
                    descr: e.target.value,
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none",
                }}
              />{" "}
              {/**            
              <Button
                onClick={() => this.pdfAction("fechaRespueReclP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>        boton pdf  fechaRespueReclP */}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Informe Adicional"
                value={this.state.fechaInfoAdici}
                onChange={this.handleInfoAdic}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaInfoAdiciP"
                Key="fechaInfoAdiciP"
                onChange={this.onChangeHandler}
                multiple
                type="file"
              />
              <label htmlFor="fechaInfoAdiciP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaInfoAdiciP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment3}
                onChange={(e) =>
                  this.setState({
                    coment3: e.target.value,
                    descr: e.target.value,
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none",
                }}
              />{" "}
              {/**                       
              <Button
                onClick={() => this.pdfAction("fechaInfoAdiciP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>               fechaInfoAdiciP              boton */}
            </div>

            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Entrega Informe Adic."
                value={this.state.fechaEntregInfAdi}
                onChange={this.handleEntregInfAdi}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaEntregInfAdiP"
                key="fechaEntregInfAdiP"
                onChange={this.onChangeHandler}
                multiple
                type="file"
              />
              <label htmlFor="fechaEntregInfAdiP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaEntregInfAdiP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment4}
                onChange={(e) =>
                  this.setState({
                    coment4: e.target.value,
                    descr: e.target.value,
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none",
                }}
              />{" "}
              {/**                 
              <Button
                onClick={() => this.pdfAction("fechaEntregInfAdiP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>    fechaEntregInfAdiP               <sd<sd */}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Entrega Informe Final"
                value={this.state.fechaEntregInfFin}
                onChange={this.handleEntregInfFin}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                key="fechaEntregInfFinP"
                id="fechaEntregInfFinP"
                onChange={this.onChangeHandler}
                multiple
                type="file"
              />
              <label htmlFor="fechaEntregInfFinP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{
                    margin: "20px",
                    textTransform: "none",
                  }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaEntregInfFinP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment5}
                onChange={(e) =>
                  this.setState({
                    coment5: e.target.value,
                    descr: e.target.value,
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none",
                }}
              />{" "}
              {/**                    
              <Button
                onClick={() => this.pdfAction("fechaEntregInfFinP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>    fechaEntregInfFinP     *********************  */}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Respuesta Institucion"
                value={this.state.fechaRespFinalAseg}
                onChange={this.handleRespFinAseg}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaRespFinalAsegP"
                key="fechaRespFinalAsegP"
                onChange={this.onChangeHandler}
                multiple
                type="file"
              />
              <label htmlFor="fechaRespFinalAsegP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaRespFinalAsegP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment6}
                onChange={(e) =>
                  this.setState({
                    coment6: e.target.value,
                    descr: e.target.value,
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none",
                }}
              />{" "}
              {/*/                       
              <Button
                onClick={() => this.pdfAction("fechaRespFinalAsegP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>            fechaRespFinalAsegP         ****************************/}
            </div>

            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Informe Final"
                value={this.state.fechaInformeFinal}
                onChange={this.handleInfoFin}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaInformeFinalP"
                key="fechaInformeFinalP"
                onChange={this.onChangeHandler}
                multiple
                type="file"
              />
              <label htmlFor="fechaInformeFinalP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaInformeFinalP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment7}
                onChange={(e) =>
                  this.setState({
                    coment7: e.target.value,
                    descr: e.target.value,
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",

                  textTransform: "none",
                }}
              />{" "}
              {/*                             
              <Button
                onClick={() => this.pdfAction("fechaInformeFinalP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>        fechaInformeFinalP *******************    */}
            </div>
          </Grid>
        </MuiPickersUtilsProvider>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {window.respuesta.checkedC ? (
            <>
              <Button
                onClick={this.consluir}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Concluir
              </Button>
              <Button
                onClick={this.save}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Guardar
              </Button>
            </>
          ) : null}
        </div>
        <div>
          <Dialog
            open={this.state.open}
            onClose={this.consluir}
            aria-labelledby="form-dialog-title"
          >
            <Conclusion
              consluir={this.consluir}
              descr={this.state.descr}
              guardarConclusion={this.guardarConclusion}
              text={"Motivo de Conclusion"}
              setDescr={this.setDescr}
            />
          </Dialog>
        </div>

        <Archivos
          lista={this.state.lista}
          abrir={this.state.openPdf}
          cerrar={this.cerrar}
          eliminar={this.eliminarAr}
        />
        {this.state.guardado && (
          <SnackBar
            open={this.state.guardado}
            handleClick={this.handleClick}
            handleClose={this.handleClose}
          />
        )}
      </div>
    );
  }
  cerrar = () => {
    this.setState({ openPdf: !this.state.openPdf });
  };

  eliminarAr = (archivo, url, nombre) => {
    const y = "fase1." + this.state.gui;
    const x = {
      [y]: firebase.firestore.FieldValue.arrayRemove({
        bucket: archivo,
        nombre: nombre,
        url: url,
      }),
    };

    const datosFiltrados = this.state.lista.filter((i) => {
      return i.nombre !== nombre;
    });

    this.setState({ lista: datosFiltrados });
    this.setState({ [this.state.gui]: datosFiltrados });

    firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update(x);
  };

  pdfAction = (gui) => {
    this.setState({ gui: gui });
    switch (gui) {
      case "fechaReclamoP":
        this.setState({ lista: this.state.fechaReclamoP });
        break;
      case "fechaRespueReclP":
        this.setState({ lista: this.state.fechaRespueReclP });
        break;
      case "fechaInfoAdiciP":
        this.setState({ lista: this.state.fechaInfoAdiciP });
        break;
      case "fechaEntregInfAdiP":
        this.setState({ lista: this.state.fechaEntregInfAdiP });
        break;
      case "fechaEntregInfFinP":
        this.setState({ lista: this.state.fechaEntregInfFinP });
        break;
      case "fechaRespFinalAsegP":
        this.setState({ lista: this.state.fechaRespFinalAsegP });
        break;
      case "fechaInformeFinalP":
        this.setState({ lista: this.state.fechaInformeFinalP });
        break;

      default:
        console.log("algo salio mal");
    }
    this.setState({ openPdf: !this.state.openPdf });
  };
  consluir = () => {
    this.setState({ open: !this.state.open });
  };
  guardarConclusion = async () => {
    await firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update({
        estado: 3,
        descr: this.state.descr,
        etapa: "1-Directa",
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      });
    this.setState({ open: !this.state.open });
    this.handleClick();
  };
  setDescr = (e) => {
    this.setState({ descr: e.target.value });
  };

  save = async () => {
    await firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update({
        fase1: {
          numSinsitro: this.state.numSinsitro,
          nombInsti: this.state.nombInsti,
          fechaReclamo: this.state.fechaReclamo,
          coment1: this.state.coment1,
          fechaRespueRecl: this.state.fechaRespueRecl,
          coment2: this.state.coment2,
          fechaInfoAdici: this.state.fechaInfoAdici,
          coment3: this.state.coment3,
          fechaEntregInfAdi: this.state.fechaEntregInfAdi,
          coment4: this.state.coment4,
          fechaEntregInfFin: this.state.fechaEntregInfFin,
          coment5: this.state.coment5,
          fechaRespFinalAseg: this.state.fechaRespFinalAseg,
          coment6: this.state.coment6,
          fechaInformeFinal: this.state.fechaInformeFinal,
          coment7: this.state.coment7,
          fechaReclamoP: this.state.fechaReclamoP,
          fechaRespueReclP: this.state.fechaRespueReclP,
          fechaInfoAdiciP: this.state.fechaInfoAdiciP,
          fechaEntregInfAdiP: this.state.fechaEntregInfAdiP,
          fechaEntregInfFinP: this.state.fechaEntregInfFinP,
          fechaRespFinalAsegP: this.state.fechaRespFinalAsegP,
          fechaInformeFinalP: this.state.fechaInformeFinalP,
        },
        descr: this.state.descr,
        etapa: "1-Directa",
        // archivos: this.archivoState,
        actualizado: this.props.selectedNote.name,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      });

    await firebase
      .firestore()
      .collection("notificaciones")
      .add({
        text: `${this.props.selectedNote.name} ha actualizado el caso #${this.props.selectedNote.title}`,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((doc) => console.log("notificacion", doc));
    this.handleClick();
  };

  onChangeHandler = async (event) => {
    const gui = event.target.id;
    await this.setState({ archivo: event.target.files[0] });
    const arch = this.state.archivo;
    const name = arch.name;
    let metadata = {
      contentType: "document/pdf",
    };

    const storageRef = firebase.storage().ref(this.props.selectedNote.id);
    let uploadTask = storageRef
      .child(gui + "/" + arch.name)
      .put(arch, metadata);

    let dele = this.props.selectedNote.id + "/" + gui + "/" + arch.name;
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function (snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        /*  () => {
          this.setState({ open2: true });
        };*/
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");

            //setTimeout(function() {w.close();}, 5000)
            break;

          default:
            console.log("se fue al deafult case");
            break;
        }
        /* () => {
          this.setState({ open2: false });
        };*/
      },
      function (error) {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            console.log("User doesnt have permission to access the object");
            break;

          case "storage/canceled":
            // User canceled the upload
            console.log("User canceled the upload");
            break;

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            console.log("Unknown error occurred, inspect error.serverResponse");
            break;
          default:
            console.log("se fue al deafult case");
            break;
        }
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          console.log("File available at", downloadURL);
          //this.setState({archivoState: downloadURL })
          //this.state[gui].push(this.state.archivoState); //LLENADO DE LA VARIABLE CON LO QUE SE VA SUBIENDO AL MOMENTO

          switch (gui) {
            case "fechaReclamoP":
              this.setState((prevState) => ({
                fechaReclamoP: [
                  ...prevState.fechaReclamoP,
                  { nombre: name, url: downloadURL, bucket: dele },
                ],
              }));
              break;
            case "fechaRespueReclP":
              this.setState((prevState) => ({
                fechaRespueReclP: [
                  ...prevState.fechaRespueReclP,
                  { nombre: name, url: downloadURL, bucket: dele },
                ],
              }));
              break;
            case "fechaInfoAdiciP":
              this.setState((prevState) => ({
                fechaInfoAdiciP: [
                  ...prevState.fechaInfoAdiciP,
                  { nombre: name, url: downloadURL, bucket: dele },
                ],
              }));
              break;
            case "fechaEntregInfAdiP":
              this.setState((prevState) => ({
                fechaEntregInfAdiP: [
                  ...prevState.fechaEntregInfAdiP,
                  { nombre: name, url: downloadURL, bucket: dele },
                ],
              }));
              break;
            case "fechaEntregInfFinP":
              this.setState((prevState) => ({
                fechaEntregInfFinP: [
                  ...prevState.fechaEntregInfFinP,
                  { nombre: name, url: downloadURL, bucket: dele },
                ],
              }));
              break;
            case "fechaRespFinalAsegP":
              this.setState((prevState) => ({
                fechaRespFinalAsegP: [
                  ...prevState.fechaRespFinalAsegP,
                  { nombre: name, url: downloadURL, bucket: dele },
                ],
              }));
              break;
            case "fechaInformeFinalP":
              this.setState((prevState) => ({
                fechaInformeFinalP: [
                  ...prevState.fechaInformeFinalP,
                  { nombre: name, url: downloadURL, bucket: dele },
                ],
              }));
              break;

            default:
              console.log("algo salio mal");
          }
          this.save();
        });
      }
    );
  };
}
export default Etapa1;
